export default function(store, action) {
  return {
    ...store,
    hint: {
      ...store.hint,
      block: action.toggle,
    },
  }
}
